var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.numberOfEvents)+" "+_vm._s(_vm.$t("selected")))])}
var staticRenderFns = []

export { render, staticRenderFns }